<template functional>
  <nav
    :class="[data.class, data.staticClass, 'breadcrumbs']"
    :style="[data.style, data.staticStyle]"
    v-bind="data.attrs"
    :aria-label="props.ariaLabel"
    itemscope
    itemtype="https://schema.org/BreadcrumbList"
    v-on="listeners"
  >
    <ol class="breadcrumbs__list">
      <li
        v-for="(breadcrumb, i) in props.breadcrumbs"
        :key="i"
        class="breadcrumbs__list-item"
        :aria-current="$options.breadcrumbLast(props.breadcrumbs) === i && 'page'"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        <template v-if="$options.breadcrumbLast(props.breadcrumbs) !== i">
          <slot name="link" v-bind="{ breadcrumb }">
            <component
              :is="'nuxt-link'"
              class="breadcrumbs__breadcrumb"
              :to="breadcrumb.link"
              itemprop="item"
            >
              <span itemprop="name">{{ breadcrumb.text }}</span>
              <meta itemprop="url" :content="$options.getLinkWithStoreURL(breadcrumb.link)">
              <meta itemprop="position" :content="i + 1">
            </component>
          </slot>
        </template>
        <template v-else>
          <slot name="current" v-bind="{ breadcrumb }">
            <component
              :is="'nuxt-link'"
              :to="breadcrumb.link"
              class="breadcrumbs__breadcrumb current"
              itemprop="item"
            >
              <span itemprop="name">{{ breadcrumb.text }}</span>
              <meta itemprop="url" :content="$options.getLinkWithStoreURL(breadcrumb.link)">
              <meta itemprop="position" :content="i + 1">
            </component>
          </slot>
        </template>
      </li>
    </ol>
  </nav>
</template>

<script>
import { useContext } from '@nuxtjs/composition-api'
export default {
  name: 'CategoryBreadcrumbs',
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    ariaLabel: {
      type: String,
      default: 'breadcrumb'
    }
  },
  breadcrumbLast (breadcrumbs) {
    return breadcrumbs.length - 1
  },
  getLinkWithStoreURL (link) {
    const { $config } = useContext()
    const { storeURL } = $config

    return storeURL + link
  }
}
</script>
<style lang="scss">
.breadcrumbs {
  padding: var(--breadcrumbs-padding, 30px 0);
  &__list {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
    list-style: none;
  }
  &__list-item {
    display: flex;
    align-items: center;
    justify-content: center;

    &:not(:last-child) {
      &::after {
        margin: var( --breadcrumbs-list-item-before-padding, 0 8px);
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 50%;
        display: inline-block;
        background: var(--breadcrumbs-list-item-before-color, var(--c-grey-1));
      }
    }
  }
  &__breadcrumb {
    font-weight: var(--breadcrumbs-list-item-font-weight, 400);
    font-size: var(--breadcrumbs-list-item-font-size, 14px);
    line-height: var(--breadcrumbs-list-item-line-height, 16px);
    --link-color: var(--c-grey);
    --link-text-decoration: none;
    &:hover {
      --link-color: var(--c-black);
    }
    &.current {
      --link-color: var(--c-black);
      cursor: default;
    }
  }
}
</style>
